import React from 'react';
import { Box, Typography } from '@mui/material';
import { WriteoffSearchView } from '../../../../../../services/WriteoffService/types';

interface PatientAccountTemplateProps {
  patientName?: string;
  accountNumber?: string;
}

/**
 * Combined patient name and account number display for lookup results.
 */
export const PatientAccountTemplate: React.FC<PatientAccountTemplateProps> = ({
  patientName,
  accountNumber,
}) => (
  <Box sx={{ py: 0.5 }}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {patientName || '-'}
    </Typography>
    <Typography variant="caption" sx={{ color: '#64748b', fontFamily: 'monospace' }}>
      {accountNumber || '-'}
    </Typography>
  </Box>
);

/** Syncfusion grid template wrapper */
export const patientAccountTemplate = (props: WriteoffSearchView) => (
  <PatientAccountTemplate patientName={props.patientName} accountNumber={props.accountNumber} />
);

export default PatientAccountTemplate;
